import { IMemberListInfo, getMemberList } from "@umu/umu-api";
import { fetchData } from "@umu/umu-fetch";
import { API_TYPE, IListItem, IMemberList, EPlatformTravelType as TravelType } from "@umu/umu-types";
interface IMemberDataInfoParams {
    department_id:string;
    page: number
    size: number;
}
interface IMemberDataInfoTransformRes {
    list: IListItem[];
    pageInfo: {
        totalPage: number;
        count: number;
        currentPage: number;
    };
}
interface IMemberDataInfoOptions {
    defaultSelectedList: string[];
    isInit: boolean;
    onTransform: (res: IMemberListInfo) => IMemberDataInfoTransformRes
}
const defaultMemberDataInfo = {
    list: [],
    pageInfo: {
        totalPage: 0,
        count: 0,
        currentPage: 0,
    }
}

const getMemberDataInfo = async (params: IMemberDataInfoParams, options: IMemberDataInfoOptions) => {
    const { defaultSelectedList, isInit, onTransform } = options;
    const total = defaultSelectedList.length;
    if(isInit && total > params.size){
        params.size = total;
    }
    const listInfo = await getMemberList(params)
    return onTransform(listInfo);
}
const onTransformMemberData = (res: IMemberListInfo) => {
    if (!res || !res.list) {
        return defaultMemberDataInfo;
    }
    const { list = [], page_info } = res || {
        list: [],
        page_info: {
            total_page_num: 0,
            list_total_num: 0,
            current_page: 0,
        }
    };
    const data: IListItem[] = list.map((item: IMemberList) => {
        return {
            checkable: true,
            isSelected: false,
            type: TravelType.owner,
            id: item.user_info.umu_id,
            name: item.user_info.user_name || item.name,
            avatar: item.user_info.avatar,
            oriData: item,
        }
    });
    return {
        list: data,
        pageInfo: {
            totalPage: page_info.total_page_num,
            count: page_info.list_total_num,
            currentPage: page_info.current_page,
        }
    }
}

const getMemberInfoByUmuIds = (data: { umu_ids: string }) => {
    return fetchData(
        {
            url: `/uapi/v1/enterprise/get-user-infos`,
            type: API_TYPE.GET,
        },
        data,
    ).then((res: IListResponse<IMemberListInfo>) => {
        return res.data;
    });
};

export function getMemberKeyByItem(item: any) {
    const umu_id = item.id || item.oriData.users_info.umu_id;
    const department_id = item.oriData.department_id;
    return department_id ? `${TravelType.owner}-${department_id}-${umu_id}` : `${TravelType.owner}-${umu_id}`;
}

/**
 * @description: 构造 MemberItem
 *
 */

function normMemberItem(item: any, isSelected?: boolean): IListItem {
    const user_info = item.user_info || item;
    const umu_id = user_info.umu_id || user_info.id;
    const user_name = user_info.user_name || user_info.name;

    const itemNew = {
        key: '',
        id: umu_id,
        name: user_name,
        checkable: true,
        type: TravelType.owner,
        avatar: user_info.avatar,
        isSelected: isSelected == undefined ? false : isSelected,

        oriData: {
            ...item,
            umu_id,
            user_info,
            user_name,
            name: user_name,
        },
    };

    itemNew.key = getMemberKeyByItem(itemNew);

    return itemNew;
}


export {
    normMemberItem,
    getMemberDataInfo,
    onTransformMemberData,
    getMemberInfoByUmuIds
}
